<template>
  <el-form style="margin: 0 10px" ref="form" :model="form" label-position="top">
    <el-form-item label="插件状态" prop="state" :rules="{ required: true, message: '请选择插件状态' }">
      <el-radio-group v-model="form.state">
        <el-radio label="Published">审核成功</el-radio>
        <el-radio label="Rejected">需改进</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      v-if="form.state == 'Rejected'"
      label="拒绝理由"
      prop="message"
      :rules="{ required: true, message: '请输入拒绝理由' }"
    >
      <el-input v-model="form.message" placeholder="请输入拒绝理由"></el-input>
    </el-form-item>
    <el-form-item v-if="form.state == 'Published'" label="选项">
      <el-checkbox v-model="form.isFeatured">精选插件</el-checkbox>
    </el-form-item>
  </el-form>

  <el-divider></el-divider>

  <div class="el-dialog__footer">
    <el-button type="primary" @click="btnSubmitClick">确 定</el-button>
    <el-button @click="btnCancelClick">取 消</el-button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import utils from '@/utils';
import api from '@/api/admin/extensions';
import { IExtension } from '@/types/models';
import { IElForm } from '@/types/element';

interface IForm {
  userName: string;
  name: string;
  state: string;
  message: string;
  isFeatured: boolean;
}

interface IState {
  form: IForm;
}

export default defineComponent({
  emits: ['cancel', 'submit'],
  props: {
    extension: {
      type: Object as PropType<IExtension>,
      required: true,
    },
  },
  data() {
    return {
      form: { ...this.extension },
    } as IState;
  },
  methods: {
    apiSubmit() {
      api.submit(
        {
          userName: this.form.userName,
          name: this.form.name,
          state: this.form.state,
          message: this.form.message,
          isFeatured: this.form.isFeatured,
        },
        (res) => {
          if (!res.value) return;

          utils.success('插件状态设置成功！');
          this.$emit('submit', this.form);
        },
      );
    },

    btnCancelClick() {
      this.$emit('cancel');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },
  },
  watch: {
    extension(value) {
      this.form = { ...value };
    },
  },
});
</script>
